export interface RsaDefaultImageSet {
  square: { storagePath: string; staticUrl: string };
  landscape: { storagePath: string; staticUrl: string };
}

interface ApiResponse {
  square: { storagePath: string; staticUrl: string } | null;
  landscape: { storagePath: string; staticUrl: string } | null;
  quarter: string | null;
}

/**
 * Fetch RSA default images for a nameplate from the backend.
 * The backend resolves the nameplate to the correct folder and quarter.
 */
export async function fetchRsaDefaults(
  nameplate: string | undefined | null,
): Promise<RsaDefaultImageSet | null> {
  if (!nameplate) return null;

  try {
    const res = await fetch(`/api/static/rsa-defaults/${encodeURIComponent(nameplate)}`);
    if (!res.ok) return null;

    const data: ApiResponse = await res.json();
    if (!data.square || !data.landscape) return null;

    return {
      square: data.square,
      landscape: data.landscape,
    };
  } catch {
    return null;
  }
}
